import { Node } from '@tiptap/core'
import { VueNodeViewRenderer, mergeAttributes } from "@tiptap/vue-3"
import View from "./View.vue"

export default Node.create({
  name: 'IFrame',

  group: 'block',

  atomic: true,

  draggable: true,

  addAttributes() {
    return {
      src: {
        default: '',
      },
      width: {
        default: '640px',
      },
      height: {
        default: '500',
      },
      justify: {
        default: 'center',
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'tt-iframe',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['tt-iframe', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(View)
  }
})
